import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../Icon';

const ContextMenuItem = ({
  iconProps,
  iconVariant,
  label,
  labelProps,
  onClick,
  className,
  value,
  optionProps
}) => (
  <div
    onClick={event => onClick(value, event)}
    className={classnames('pt-1x pb-1x pl-3x pr-3x', className)}
    role='presentation'
    {...optionProps}
  >
    {iconVariant && <Icon variant={iconVariant} {...iconProps} />}
    <span {...labelProps}>{label}</span>
  </div>
);

ContextMenuItem.propTypes = {
  className: PropTypes.string,
  iconProps: PropTypes.object,
  iconVariant: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelProps: PropTypes.object,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number
  ]),
  optionProps: PropTypes.object
};

export default ContextMenuItem;
